import { Building } from "lucide-react";
import { AiOutlineTransaction } from "react-icons/ai";
import {
  MdOutline3dRotation,
  MdOutlineApartment,
  MdOutlineCampaign,
  MdOutlineDashboard,
  MdOutlineDescription,
  MdOutlineVerifiedUser,
} from "react-icons/md";

export const mainSidebarLinks = [
  {
    name_en: "Dashboard",
    name_ar: "لوحة التحكم",
    href: "/dashboard",
    icon: MdOutlineDashboard,
  },
  {
    name_en: "My Properties",
    name_ar: "عقاراتي",
    href: "/dashboard/properties",
    icon: Building,
  },
  {
    name_en: "Account Status",
    name_ar: "حالة الحساب",
    href: "/dashboard/account",
    icon: MdOutlineVerifiedUser,
  },
  {
    name_en: "Documents & Licences",
    name_ar: "المستندات والتراخيص",
    href: "/dashboard/documents",
    icon: MdOutlineDescription,
  },
  {
    name_en: "Transactions",
    name_ar: "المعاملات",
    href: "/dashboard/transactions",
    icon: AiOutlineTransaction,
  },
  {
    name_en: "Real Estate Projects",
    name_ar: "المشاريع العقارية",
    href: "/dashboard/projects",
    icon: MdOutlineApartment,
  },
  {
    name_ar: "التصوير ثلاثي الأبعاد",
    name_en: "3D Photography",

    subMenu: [
      {
        name_ar: "الأسعار",
        name_en: "Pricing",
        href: "/dashboard/3d-photography/pricing",
      },
      {
        name_ar: "طلباتي",
        name_en: "My Orders",
        href: "/dashboard/3d-photography/orders",
      },
      {
        name_ar: "اشتراكاتي",
        name_en: "My Subscriptions",
        href: "/dashboard/3d-photography/subscriptions",
      },
    ],
    icon: MdOutline3dRotation,
  },

  {
    name_ar: "الإعلانات",
    name_en: "Advertisements",
    icon: MdOutlineCampaign,
    subMenu: [
      {
        name_ar: "إعلاناتي",
        name_en: "My Ads",
        href: "/dashboard/ads/my-ads",
      },
      {
        name_ar: "إنشاء إعلان جديد",
        name_en: "Create New Ad",
        href: "/dashboard/ads/create",
      },
    ],
  },

  // {
  //   name_en: "Support",
  //   name_ar: "الدعم",
  //   href: "/dashboard/support",
  //   icon: BiSupport,
  // },
];
